import { render } from "./PropertiesXAxisString.vue?vue&type=template&id=4723e445"
import script from "./PropertiesXAxisString.vue?vue&type=script&lang=js"
export * from "./PropertiesXAxisString.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__